import Flag from "react-flagpack";

import { getLocaleCountryCode } from "@/lib/locales";
import { cn } from "@/lib/utils";

interface LocaleFlagProps {
  tag: string;
  size?: "S" | "M" | "L";
  className?: string;
}

const FLAG_CODE_ALIASES: Record<string, string> = {
  // Flagpack ships UK as GBR, not GB.
  GB: "GBR",
};

export function LocaleFlag({ tag, size = "S", className }: LocaleFlagProps) {
  const countryCode = getLocaleCountryCode(tag);
  const normalizedCode = FLAG_CODE_ALIASES[countryCode] ?? countryCode;

  if (!/^[A-Z]{2,3}$/.test(normalizedCode)) {
    return (
      <span
        className={cn(
          "inline-flex h-4 min-w-6 items-center justify-center rounded bg-muted px-1 text-[10px] font-semibold text-muted-foreground",
          className,
        )}
      >
        {countryCode || "--"}
      </span>
    );
  }

  return (
    <Flag
      code={normalizedCode}
      // react-flagpack builds the asset path as `/flags/${size}/${code}.svg`.
      // The shipped flag folders are lowercase (public/flags/{s,m,l}); passing
      // the uppercase prop 404s on case-sensitive hosts (Firebase CDN) while
      // resolving locally on case-insensitive macOS. Lowercase to match.
      size={size.toLowerCase()}
      hasBorder
      hasBorderRadius
      className={cn("shrink-0", className)}
    />
  );
}